import { 
  RECEIVE_ERROR_RESPONSE,
  CLEAR_API_ERROR,
} from '../constants/actionTypes';

export const receiveErrorResponse = (error) => {
  let errorObj;
  if(!error) {
    errorObj = { 
      response: {
        status: 400,
      },
    };
  } else if(error === 'No current user') {
    errorObj = { 
      response: {
        status: 403,
      },
    };
  } else {
    errorObj = error;
  }
  return {
    type: RECEIVE_ERROR_RESPONSE,
    error: errorObj,
  };
};

export const clearApiError = () => ({
  type: CLEAR_API_ERROR,
});